export default __webpack_public_path__ + "static/media/manualBilling.95fb88a3.svg";